import { PageBase } from '.'
import { GridRow } from '../..'

export class PageResponse extends PageBase {
    components: any
    ancestorComponents: any
    gridContent: GridRow[]
    pageTitle: string
}
